import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';

import { narsilApis } from '@flipster/apis/v1/dynamic-earn';
import { overlayBunja } from '@flipster/overlay';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { NrsusdtpCurrency } from '@flipster/utils/constants/currency';

import { narsilTerms } from '../../main-page/misc/agree-checkbox';
import { NarsilOverviewQueryKey, narsilDetailsBunja, narsilMintOverviewBunja, narsilOverviewBunja } from '../state';
import { createSubscribeModal } from './create-subscribe-modal';
import { DepositToSubscribeModal } from './deposit-to-subscribe-modal';

export type { SubscribeResult } from './create-subscribe-modal';

// ─── Narsil ────────────────────────────────────────────────

const {
  SubscribeModal: NarsilSubscribeModal,
  LiquidationRiskCheckModal: NarsilLiquidationRiskCheckModal,
  liquidationRiskCheckedBunja: narsilLiquidationRiskCheckedBunja,
} = createSubscribeModal({
  mintOverviewBunja: narsilMintOverviewBunja,
  detailsBunja: narsilDetailsBunja,
  collateralBunja: narsilOverviewBunja,
  previewApi: narsilApis.postMintPreview,
  confirmApi: narsilApis.postMintConfirm,
  overviewQueryKey: NarsilOverviewQueryKey,
  liquidationRiskErrorCode: 'api.narsil.mint.liquidationRisk',
  liquidationRiskLocalStorageKey: 'narsilDynamicEarnLiquidationRiskChecked',
  productName: 'Narsil USDT Prime',
  currency: NrsusdtpCurrency,
  terms: narsilTerms,
  toLabelId: 'Earn.r260601.To_narsil_usdt_prime',
});

export { NarsilSubscribeModal };

const openNrsusdtpSubscribeModalBunja = bunja(() => {
  const overlay = bunja.use(overlayBunja);
  const store = bunja.use(JotaiStoreScope);
  const { checkedAtom } = bunja.use(narsilLiquidationRiskCheckedBunja);
  const { hasSubscribableBalanceAtom } = bunja.use(narsilMintOverviewBunja);

  function openNrsusdtpSubscribeModal() {
    const hasSubscribableBalance = store.get(hasSubscribableBalanceAtom);
    const liquidationRiskChecked = store.get(checkedAtom);

    if (!hasSubscribableBalance) {
      overlay.open(({ isOpen, onClose, unmount }) => (
        <DepositToSubscribeModal isOpen={isOpen} onClose={onClose} onExit={unmount} />
      ));
    } else if (!liquidationRiskChecked) {
      overlay.open(({ isOpen, onClose, unmount }) => (
        <NarsilLiquidationRiskCheckModal
          isOpen={isOpen}
          onClose={onClose}
          onConfirm={() => {
            overlay.open(({ isOpen, onClose, unmount }) => (
              <NarsilSubscribeModal isOpen={isOpen} onClose={onClose} onExit={unmount} />
            ));
          }}
          onExit={unmount}
        />
      ));
    } else {
      overlay.open(({ isOpen, onClose, unmount }) => (
        <NarsilSubscribeModal isOpen={isOpen} onClose={onClose} onExit={unmount} />
      ));
    }
  }

  return { openNrsusdtpSubscribeModal };
});
openNrsusdtpSubscribeModalBunja.debugLabel = 'openNrsusdtpSubscribeModalBunja';

export const useNrsusdtpSubscribeModal = () => {
  const { openNrsusdtpSubscribeModal } = useBunja(openNrsusdtpSubscribeModalBunja);
  return openNrsusdtpSubscribeModal;
};
